import React, { Suspense, useEffect, useState } from "react";
import { Transition } from "react-transition-group";
import { Spinner } from "components/Spinner/Spinner";
import Cross from "../../assets/Icon_Modal_Cross.png";
import ErrorBoundary from "components/ErrorBoundary";
import ErrorFallback from "components/fallbacks/ErrorFallback";

export interface RightPanelProps {
  rightPanelContent: boolean | null;
  closePanel(): void;
  title?: string | React.ReactNode;
  headerElement?: React.ReactElement;
  largeRightPanel?: boolean;
  extraClassNames?: string;
}

const transitionStyles = {
  entering: { transform: "translateX(101%)" },
  entered: { transform: "translateX(0)" },
};

const RightPanel: React.FC<RightPanelProps> = ({
  children,
  rightPanelContent,
  closePanel,
  title = "Right panel",
  headerElement,
  largeRightPanel,
  extraClassNames,
}) => {
  return (
    <Transition in={!!rightPanelContent} timeout={0} mountOnEnter unmountOnExit>
      {transitionState => (
        <>
          <div
            className={"RightPanelUnderlay " + transitionState}
            onMouseDown={closePanel}
          />
          <div
            className={
              `RightPanel ${largeRightPanel ? "LargeRightPanel " : " "} ${
                extraClassNames ? ` ${extraClassNames} ` : " "
              }` + transitionState
            }
          >
            <div className="Inner">
              <div className="Top">
                {typeof title === "string" ? (
                  <h2 className="Title">{title}</h2>
                ) : (
                  title
                )}

                {headerElement && (
                  <div className="HeaderElement">{headerElement}</div>
                )}

                <div className="Cross">
                  <img src={Cross} alt="Cross" onClick={closePanel} />
                </div>
              </div>
              <Suspense fallback={<Spinner positionAbsolute />}>
                <ErrorBoundary fallback={<ErrorFallback />}>
                  {children ?? null}
                </ErrorBoundary>
              </Suspense>
            </div>
          </div>
        </>
      )}
    </Transition>
  );
};

export { RightPanel };
